import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Phone, ChevronRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

const RecentPatientsList = ({ patients }) => {
  const navigate = useNavigate();

  return (
    <Card className="bg-white border border-slate-200 shadow-sm">
      <CardHeader className="pb-4 border-b border-slate-100">
        <div className="flex items-center justify-between">
          <CardTitle className="font-heading text-lg font-semibold text-slate-800 flex items-center gap-2">
            <Users className="w-5 h-5 text-brand-cyan" strokeWidth={1.5} />
            Últimos Pacientes
          </CardTitle>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={() => navigate('/pacientes')}
            className="text-brand-main hover:text-brand-dark hover:bg-brand-main/5"
            data-testid="view-all-patients"
          >
            Ver todos
            <ChevronRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        {patients.length === 0 ? (
          <div className="p-6 text-center text-slate-400">
            <Users className="w-12 h-12 mx-auto mb-3 opacity-30" />
            <p>No hay pacientes registrados</p>
          </div>
        ) : (
          <ul className="divide-y divide-slate-100" data-testid="recent-patients-list">
            {patients.map((patient) => (
              <li key={patient.id} className="p-4 hover:bg-slate-50 transition-colors">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-brand-cyan/5 flex items-center justify-center flex-shrink-0">
                    <span className="font-heading font-semibold text-brand-cyan">
                      {patient.nombre.charAt(0).toUpperCase()}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                      <p className="font-medium text-slate-800 truncate">
                        {patient.nombre}
                      </p>
                      <Badge 
                        variant={patient.enviado ? "default" : "secondary"}
                        className={patient.enviado 
                          ? "bg-emerald-100 text-emerald-700 border-0" 
                          : "bg-amber-100 text-amber-700 border-0"
                        }
                      >
                        {patient.enviado ? 'Enviado' : 'Pendiente'}
                      </Badge>
                    </div>
                    <div className="flex items-center gap-4 text-sm text-slate-500">
                      <span className="flex items-center gap-1">
                        <Phone className="w-3 h-3" />
                        {patient.telefono}
                      </span>
                      <span>{patient.tipo_examen}</span>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
};

export default RecentPatientsList;
